import { MsalAuthProvider, LoginType } from "react-aad-msal";

var redirectUri = "http://localhost:4040";
// var clientId = "ebbd6848-d7e3-43e1-9494-b0e60164af5a";
var clientId = "544ae0a9-0b62-459c-bd46-d58aca08df7e";

if (process.env.REACT_APP_STAGE === "Dev") {
  redirectUri = "https://app-employee-portal-finance-dev.azurewebsites.net";
  // clientId = "ebbd6848-d7e3-43e1-9494-b0e60164af5a";
  clientId = "544ae0a9-0b62-459c-bd46-d58aca08df7e";
}
if (process.env.REACT_APP_STAGE === "Test") {
  redirectUri = "https://app-employee-portal-finance-tst.azurewebsites.net";
  clientId = "544ae0a9-0b62-459c-bd46-d58aca08df7e";
} else if (process.env.REACT_APP_STAGE === "Production") {
  redirectUri = "https://employee-finance.hafnia.com";
  clientId = "e6740d56-4bb7-4304-803b-4258d96cf095";
}

// Portal
const msalConfig = {
  auth: {
    authority:
      "https://login.microsoftonline.com/a364eb28-e95b-4ad0-a4fb-5b4f7767ad84",
    clientId: clientId,
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const authParameters = {
  scopes: ["api://583fded1-b0aa-48aa-ba5f-1417366c7d06/Read"],
  // scopes: ["api://422132b5-d04c-4e43-a6db-6651f01a1109/Read"],
};

const authOptions = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin,
};

export const authProvider = new MsalAuthProvider(
  msalConfig,
  authParameters,
  authOptions
);
